export default __webpack_public_path__ + "static/media/logo2.cccc73a2.png";